import { getBlobAsync } from '../api.service'

// Every live organization as content builds it (GET organization/export,
// owner 2026-10-13): the Organizations page's export. The page loads a
// page at a time, so its own rows are never the whole list.
export const exportOrganizations = async () => {
  const response = await getBlobAsync(process.env.REACT_APP_API_CONTENT, 'api/ddd/organization/export')
  const url = URL.createObjectURL(response.data)
  try {
    const a = document.createElement('a')
    a.href = url
    a.download = 'organizations.csv'
    document.body.appendChild(a)
    a.click()
    a.remove()
  } finally {
    URL.revokeObjectURL(url)
  }
}
